export default function Acadefetch(jzgbh, callback) {
    fetch(`https://dandeline.tongji.edu.cn/api/Teacher_Collaborators?JZGBH=${jzgbh}`)
      .then(response => {
        if (!response.ok) {
          throw new Error(`Network response was not ok: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        callback(data);
      })
      .catch(error => {
        callback(null); 
      });
  }
  